"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M17 9v2l4-3-4-3v2h-2c-1.1795 0-2.0541.3008-2.7133.8657-.5966.5114-.9421 1.2088-1.2867 1.8982-.3446-.6894-.6901-1.3867-1.2867-1.8982C9.054 7.3007 8.1795 7 7 7H4v2h3c.8205 0 1.1959.1992 1.4117.3843.2596.2225.4292.5336.6939 1.0629L9.882 12l-.7764 1.5528c-.2647.5293-.4343.8404-.6939 1.0629C8.196 14.8008 7.8205 15 7 15H4v2h3c1.1795 0 2.0541-.3008 2.7133-.8657.5966-.5114.9421-1.2088 1.2867-1.8982.3446.6894.6901 1.3868 1.2867 1.8982C12.9459 16.6992 13.8205 17 15 17h2v2l4-3-4-3v2h-2c-.8205 0-1.1959-.1992-1.4117-.3843-.2596-.2225-.4292-.5336-.6939-1.0629L12.118 12l.7764-1.5528c.2647-.5293.4343-.8404.6939-1.063C13.8041 9.1993 14.1795 9 15 9h2z"
  })];
};

exports.default = _default;